export const CURRENT_COUNTRY_CACHE_KEY = 'cctry'; // Current country cache key
export const COUNTRIES_CACHE_KEY = 'ctrs'; // Countries cache key

export const countriesApiUrl = {
  list: '/countries',
  updateMarket: '/users/selected-market',
};
